/* unplugin-vue-components disabled */import { render } from "./ai-assistant.vue?vue&type=template&id=58151b86"
import script from "./ai-assistant.vue?vue&type=script&lang=js"
export * from "./ai-assistant.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-chat/ai-assistant/ai-assistant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58151b86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58151b86', __exports__)) {
    api.reload('58151b86', __exports__)
  }
  
  module.hot.accept("./ai-assistant.vue?vue&type=template&id=58151b86", () => {
    api.rerender('58151b86', render)
  })

}


export default __exports__